import { Icons } from "../images/icons";
import {
  BeersArray,
  CocktailsArray,
  FoodArray,
  HotDrinksArray,
  OtherArray,
  SoftsArray,
  WineArray,
  CategoriesArray,
} from "./data";

const categoryIconsMap = {
  Food: FoodArray,
  Softs: SoftsArray,
  Beers: BeersArray,
  Cocktails: CocktailsArray,
  Wine: WineArray,
  "Hot drinks": HotDrinksArray,
  Other: OtherArray,
};

const defaultIconsMap = {
  Food: Icons.food,
  Softs: Icons.soft,
  Beers: Icons.beer,
  Cocktails: Icons.cocktail,
  Wine: Icons.wine,
  "Hot drinks": Icons.drink,
  Other: Icons.others,
};

function getIcon(category, customIcon) {
  return customIcon
    ? categoryIconsMap[category]?.find((i) => i.name === customIcon)?.icon ||
        CategoriesArray.find((i) => i.name === customIcon)?.icon
    : defaultIconsMap[category];
}

export default getIcon;
